/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useState } from 'react';

// eslint-disable-next-line react/prop-types
const Accordion = ({ title, content: ContentComponent }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full mx-auto">
      <button
        type="button"
        style={{ cursor: 'pointer' }}
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 flex items-center justify-between bg-sky-50 text-black font-medium"
      >
        <span>{title}</span>
        <svg
          style={{ clipPath: 'fill-box', clipRule: 'evenodd' }}
          className={`w-6 h-6 transition-transform transform ${isOpen ? 'rotate-180' : 'rotate-0'
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      <div className="px-5">
        {isOpen && ContentComponent }
      </div>
    </div>
  );
};

export default Accordion;
